import * as React from 'react';

import PropTypes from 'prop-types';
import _ from 'underscore';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import connectToRouter from 'js/lib/connectToRouter';
import mapProps from 'js/lib/mapProps';
import path from 'js/lib/path';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import provideFluxibleAppContext from 'js/lib/provideFluxibleAppContext';
import waitFor from 'js/lib/waitFor';

import ensureEnrolled from 'pages/open-course/common/utils/ensureEnrolled';

import { Button, Typography, Typography2 } from '@coursera/cds-core';

import { CMLUtils } from 'bundles/cml';
import { addThread } from 'bundles/discussions/actions/ThreadsActions';
import { ContentInput, ForumSelector, TitleInput } from 'bundles/discussions/components/NewThreadForm';
import RequiredField from 'bundles/discussions/components/RequiredField';
import RequiredFieldLabel from 'bundles/discussions/components/RequiredFieldLabel';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import SessionFilterDropdown from 'bundles/discussions/components/personalization-sessionFilter/SessionFilterDropdown';
import { DTD_NAME, naptimeForumTypes, savingStates } from 'bundles/discussions/constants';
import DiscussionsCMLUtils from 'bundles/discussions/utils/DiscussionsCMLUtils';
import { buildUrl } from 'bundles/discussions/utils/discussionsUrl';
import routerConnectToCurrentForum from 'bundles/discussions/utils/routerConnectToCurrentForum';
import TrackedButton from 'bundles/page/components/TrackedButton';
import Modal from 'bundles/ui/components/cds/Modal';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/NewThreadButton';

type Props = {
  rootForumId?: string;
  forums: Array<Record<string, any>>;
  showSessionSelector?: boolean;
  courseId?: string;
  currentForum?: any;
  verificationDisplay?: any;
  course?: any;
  userId?: number;
  filter?: any;
  rootPath?: string;
  threadSavingState?: string;
  newThread: string;
};

type State = {
  showModal: boolean;
  title: any;
  content: any;
  currentForum: any;
  showErrors: boolean;
  saving: boolean;
  saveError: boolean;
  saveErrorMessage: string;
  activeFilterId: string;
};

type Context = {
  router: any;
};

class NewThreadButton extends React.Component<Props, State> {
  newThreadButton!: TrackedButton | null;

  submitButton!: TrackedButton | null;

  contentElemRef!: HTMLElement | null;

  forumElemRef!: HTMLElement | null;

  titleElemRef!: HTMLElement | null;

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  constructor(props: Props, context: Context) {
    super(props, context);

    this.state = this.resetState();

    // @ts-expect-error TSMIGRATION
    this.titleElemRef = {};
    // @ts-expect-error TSMIGRATION
    this.contentElemRef = {};
    // @ts-expect-error TSMIGRATION
    this.forumElemRef = {};
  }

  componentWillReceiveProps(nextProps: any) {
    const { threadSavingState } = this.props;
    const { saving } = this.state;
    // don't update the state while saving, otherwise the current forum
    // may be null when trying to navigate to the location of the new post
    if (!saving) {
      const { currentForum } = this.props;
      const currentForumValue = currentForum;
      const currentForumError = !currentForumValue;
      this.setState({
        currentForum: {
          value: currentForumValue,
          hasError: currentForumError,
        },
      });
    }

    if (threadSavingState === savingStates.SAVING && nextProps.threadSavingState === savingStates.SAVED) {
      this.handleSaveSuccess(nextProps.newThread);
    } else if (threadSavingState === savingStates.SAVING && nextProps.threadSavingState === savingStates.ERROR) {
      this.handleSaveError();
    }
  }

  handleSaveSuccess(newThread: any) {
    const { router } = this.context;
    const { currentForum } = this.state;
    const { rootPath } = this.props;
    // if we are in the aggregate view, navigate to the appropriate forum
    // @ts-expect-error TSMIGRATION
    const forumPath = path.join(rootPath, currentForum.value.link);
    router.push(buildUrl(forumPath, newThread.questionId) + '?newThread=true');
    this.setState(this.resetState());
  }

  handleSaveError() {
    this.setState({
      saveError: true,
      saveErrorMessage: _t('Something went wrong. Please reload the page and try again.'),
      saving: false,
    });
  }

  handleSubmit = () => {
    const { currentForum, activeFilterId, title, content } = this.state;
    const { userId, filter, showSessionSelector } = this.props;
    const { executeAction } = this.context;
    const hasAnyErrors = _(this.state).any((item) => item.hasError);

    if (hasAnyErrors) {
      if (title.hasError) {
        // @ts-expect-error TSMIGRATION
        this.titleElemRef.focus();
      } else if (content.hasError) {
        // @ts-expect-error TSMIGRATION
        this.contentElemRef.focus();
      } else if (currentForum.hasError) {
        // @ts-expect-error TSMIGRATION
        this.forumElemRef.focus();
      }
      this.setState({ showErrors: true });
    } else {
      const threadPostData = {
        title: title.value,
        content: content.value,
        context: '',
      };

      if (showSessionSelector) {
        threadPostData.context = activeFilterId;
      } else if (filter) {
        threadPostData.context = filter.id;
      }

      const showOverrideSessionId =
        !!threadPostData.context && threadPostData.context !== 'all' && threadPostData.context !== 'ondemand';
      const threadData = {
        content: {
          question: threadPostData.title,
          details: threadPostData.content,
        },
        overrideSessionId: showOverrideSessionId ? threadPostData.context : undefined,
        state: {},
        userId,
        courseForumId: currentForum.value.id,
        mentorForumId: currentForum.value.id,
        groupForumId: currentForum.value.id,
      };
      const { forumId } = currentForum.value;
      const forumType = currentForum.value.forumType && currentForum.value.forumType.typeName;
      this.setState({ saving: true });

      executeAction(addThread, {
        options: threadData,
        forumType,
        forumId,
      });
    }
  };

  handleDropdownChange = (filterId: string) => {
    this.setState({
      activeFilterId: filterId,
    });
  };

  handleOpenModal = () => {
    const { userId, course, verificationDisplay } = this.props;
    ensureEnrolled(userId, course, verificationDisplay).then(() => this.handleOpen());
  };

  handleCancel = () => {
    this.setState(this.resetState());
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
    });
  };

  handleInputChange = (inputName: string, event: any) => {
    // @ts-expect-error TSMIGRATION
    const { [inputName]: field } = this.state;

    field.value = event.value;
    field.hasError = !event.isValid;
    this.setState((prevState) => prevState);
  };

  handleOpen() {
    const { showModal } = this.state;
    this.setState(() => ({ showModal: !showModal }));
  }

  // remove and reinject error messages to retrigger screenreader alerts for a11y
  clearErrorsAndSubmit = () => {
    this.setState({ showErrors: false });
    setTimeout(() => {
      this.handleSubmit();
    }, 500);
  };

  resetState() {
    const { currentForum } = this.props;
    const currentForumValue = currentForum;
    const currentForumError = !currentForumValue;
    return {
      showModal: false,
      title: {
        value: '',
        hasError: true,
      },
      content: {
        value: CMLUtils.create('', DTD_NAME),
        hasError: true,
      },
      currentForum: {
        value: currentForumValue,
        hasError: currentForumError,
      },
      showErrors: false,
      saving: false,
      saveError: false,
      saveErrorMessage: '',
      activeFilterId: '',
    };
  }

  setTitleElemRef = (elem: any) => {
    this.titleElemRef = elem;
  };

  setContentElemRef = (elem: any) => {
    this.contentElemRef = elem;
  };

  setForumElemRef = (elem: any) => {
    this.forumElemRef = elem;
  };

  render() {
    const { showModal, saving, saveError, content, showErrors, title, currentForum, saveErrorMessage } = this.state;
    const { courseId, showSessionSelector, rootForumId, forums } = this.props;
    const contentLengthWarning = DiscussionsCMLUtils.generateContentLengthWarning(content.value);

    const saveErrorDisplay = <div className="error-text c-modal-error-message">{saveErrorMessage}</div>;

    let forumSelector: React.ReactNode | null = null;
    const currentForumValue = currentForum.value;
    const forumsWithoutSubforums = forums.filter(
      (forum) => !forum?.parentForumId || forum?.parentForumId === rootForumId
    );
    // reorder the forums so that subforums are directly under parent forums
    const forumsWithNestedSubforums: Array<any> = _(
      forumsWithoutSubforums.map((parentForum) =>
        [parentForum].concat(forums.filter((forum) => forum?.parentForumId === parentForum?.id))
      )
    ).flatten();

    if (forumsWithNestedSubforums.length) {
      forumSelector = (
        <div className="c-input-area">
          <RequiredField fieldName={_t('Forum')} inputId="forum-selector" />
          <ForumSelector
            id="forum-selector"
            rootForumId={rootForumId}
            hasError={showErrors && currentForum.hasError}
            handleInputChange={this.handleInputChange}
            forums={forumsWithNestedSubforums}
            value={currentForumValue}
            elemRefHook={this.setForumElemRef}
          />
        </div>
      );
    }

    let sessionSelector: undefined | React.ReactNode;
    if (showSessionSelector) {
      sessionSelector = (
        <div className="context-selector-container">
          <div className="bgcolor-divider bt3-pull-left section-divider" />
          <div className="c-input-area">
            <Typography component="h3" variant="h2semibold">
              {_t("You're currently viewing All Sessions.")}
            </Typography>
            <Typography2 component="label" htmlFor="new-thread-sessions-switcher">
              <span className="caption-text color-secondary-text">{_t('Which session should this thread go in?')}</span>
            </Typography2>
            <SessionFilterDropdown
              id="new-thread-sessions-switcher"
              hideAllSessionsOption
              limitSwitchingToCurrentBranch
              dropup
              handleDropdownChange={this.handleDropdownChange}
            />
          </div>
        </div>
      );
    }

    const modal = (
      <Modal
        onRequestClose={this.handleCloseModal}
        modalName={_t('Create a new post')}
        className="rc-personalization__NewThreadModal large"
      >
        <Typography component="h1" variant="h1semibold" className="c-modal-title">
          {_t('Create a new post')}
        </Typography>
        <RequiredFieldLabel />
        <div className="c-input-area">
          <RequiredField fieldName={_t('Title')} inputId="title-input" />
          <TitleInput
            id="title-input"
            hasError={showErrors && title.hasError}
            value={title.value}
            handleInputChange={this.handleInputChange}
            elemRefHook={this.setTitleElemRef}
          />
        </div>
        <div className="c-input-area">
          <RequiredField fieldName={_t('Body')} inputId="content-input" />
          <ContentInput
            id="content-input"
            courseId={courseId}
            hasError={showErrors && content.hasError}
            handleInputChange={this.handleInputChange}
            cml={content.value}
            elemRefHook={this.setContentElemRef}
          />
        </div>
        {forumSelector}
        {sessionSelector}
        <div>
          {contentLengthWarning}
          {saveError && saveErrorDisplay}
          <div className="horizontal-box align-items-right">
            <Button size="small" variant="secondary" type="button" onClick={this.handleCancel}>
              {_t('Cancel')}
            </Button>
            &nbsp;&nbsp;
            <Button
              component={TrackedButton}
              ref={(node: $TSFixMe) => {
                this.submitButton = node;
              }}
              disabled={saving}
              size="small"
              variant="primary"
              type="submit"
              onClick={this.clearErrorsAndSubmit}
              trackingName="new_thread_create"
              withVisibilityTracking={true}
              requireFullyVisible={false}
            >
              {_t('Post')}
            </Button>
          </div>
        </div>
      </Modal>
    );

    return (
      <div className="rc-personalization__NewThreadForm">
        <Button
          component={TrackedButton}
          className="new-thread-button"
          variant="secondary"
          size="small"
          ref={(node: $TSFixMe) => {
            this.newThreadButton = node;
          }}
          id="new-thread-btn"
          onClick={this.handleOpenModal}
          trackingName="new_thread_button"
          withVisibilityTracking={true}
          requireFullyVisible={false}
        >
          {_t('Create post')}
        </Button>
        {showModal && modal}
      </div>
    );
  }
}

const StoreConnectedNewThreadButton = _.compose(
  // TODO: connectToStores<Props, InputProps, Stores>
  connectToStores<any, any>(
    [
      'SessionFilterStore',
      'ThreadsStore',
      'ApplicationStore',
      'CourseMembershipStore',
      'VerificationStore',
      'CourseStore',
    ],
    (
      { SessionFilterStore, ThreadsStore, ApplicationStore, CourseMembershipStore, VerificationStore, CourseStore },
      props
    ) => ({
      showSessionSelector:
        (ApplicationStore.isSuperuser() || CourseMembershipStore.hasModerationRole()) &&
        SessionFilterStore.activeFilterQueryString === 'all',
      filter: SessionFilterStore.activeFilter,
      threadSavingState: ThreadsStore.savingState,
      newThread: ThreadsStore.threadToInsert,
      userId: ApplicationStore.getUserData().id,
      verificationDisplay: VerificationStore.getVerificationDisplay(),
      course: CourseStore.getMetadata(),
      courseId: CourseStore.getCourseId(),
    })
  ),
  discussionsForumsHOC({ fields: ['forumType', 'title', 'link'] }),
  connectToRouter(routerConnectToCurrentForum),
  mapProps<any, any>((props) => {
    const currentForum =
      (props.currentForum &&
        props.currentForum.forumType.typeName !== naptimeForumTypes.rootForumType &&
        props.currentForum) ||
      undefined;
    const rootForum =
      props.courseForums &&
      props.courseForums.find((forum: $TSFixMe) => forum.forumType.typeName === naptimeForumTypes.rootForumType);
    return {
      forums: props.courseForums
        ? props.courseForums
            .filter((forum: $TSFixMe) => forum.forumType.typeName !== naptimeForumTypes.rootForumType)
            .concat(props.mentorForums)
            .concat(props.groupForums)
        : [],
      rootForumId: rootForum && rootForum.id,
      // don't allow users to post to the root forum, so unset the current forum if it is root.
      currentForum,
      currentForumId: currentForum && currentForum.id,
    };
  }),
  waitFor((props) => props.forums.length)
)(NewThreadButton);

export default provideFluxibleAppContext()(StoreConnectedNewThreadButton);

// So that we can require this as a naptime component
export const NewThreadButtonNaptimeContainer = StoreConnectedNewThreadButton;

export const BaseComp = NewThreadButton;
